

<template>
  <!-- Gallery Area Start -->
  <section class="gallery_area">
    <div class="container">
      <div class="row">
        <div v-for="(item, key) in gallery" :key="key" class="col-lg-3 col-sm-6">
          <a class="gallery-lightbox" v-bind:href="require(`@/assets/img/${item.img}`)">
            <div class="gallery_item">
              <img alt="gallery" v-bind:src="require(`@/assets/img/${item.img}`)"/>
              <div class="gallery_icon">
                <svg class="feather feather-maximize" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                     stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                </svg>
              </div>
              <div class="gallery_info">
                <h3>{{item.title}}</h3>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- Pagination Start -->
      <div class="row">
        <div class="pagination-box-row">
          <p>Page 1 of 6</p>
          <ul class="pagination">
            <li><a href="#">1</a></li>
            <li class="active"><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li>...</li>
            <li><a href="#">6</a></li>
            <li><a href="#"><i class="fa fa-angle-double-right"></i></a></li>
          </ul>
        </div>
      </div>
      <!-- Pagination End -->
    </div>
  </section>
  <!-- Gallery Area End -->
</template>
<script>
export default {
  name: 'GalleryArea',
  data: function () {
    return {
      gallery: [
        {
          img: 'gallery_1.jpg',
          title: 'Classic California'
        },
        {
          img: 'gallery_2.jpg',
          title: 'Margherita Pizza'
        },
        {
          img: 'gallery_3.jpg',
          title: 'Grilled Ribs'
        },
        {
          img: 'gallery_4.jpg',
          title: 'Field Greens Pizza'
        },
        {
          img: 'gallery_5.jpg',
          title: 'Classic California'
        },
        {
          img: 'gallery_6.jpg',
          title: 'Margherita Pizza'
        },
        {
          img: 'gallery_7.jpg',
          title: 'Grilled Ribs'
        },
        {
          img: 'gallery_8.jpg',
          title: 'Field Greens Pizza'
        },
        {
          img: 'gallery_9.jpg',
          title: 'Classic California'
        },
        {
          img: 'gallery_10.jpg',
          title: 'Margherita Pizza'
        },
        {
          img: 'gallery_11.jpg',
          title: 'Grilled Ribs'
        },
        {
          img: 'gallery_12.jpg',
          title: 'Field Greens Pizza'
        },
      ]
    }
  },
  mounted() {
    $(".gallery-lightbox").magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      },
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function (openerElement) {
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GalleryArea.vue